import type { CloudinaryVideo, SanityImage } from '@time-line/components/types';
import { imageUrlBuilder } from 'lib/sanity/imageUrlBuilder';

export function getOpenGraphImage(
  media: SanityImage | CloudinaryVideo,
  width: number,
  height: number,
) {
  if (['image', 'altImage'].includes(media._type)) {
    const url = imageUrlBuilder
      .image(media)
      .width(width)
      .height(height)
      .fit('crop')
      .url();

    return url;
  }
}
